<template>
    <div style="padding-bottom: 80px; max-width: 1024px; margin-left: auto; margin-right: auto;">
        <div class="app-bar">
            <span class="app-bar-item app-bar-close"
                  @click="handleExit">닫기</span>

            <div class="app-bar-reset app-bar-item"
                 style="display: flex; justify-items: center; align-items: center;"
                 @click="handleReset">
                <img src="../../assets/ic-reset.png" style="width: 17px; height: 15px; margin-right: 4px;"/>
                <span style="align-items: center;">초기화</span>
            </div>

            <span class="app-bar-title">상세검색</span>
        </div>

        <div style="padding-top: 76px; z-index: 50;">
            <div class="location-select-container" style="width: auto;">
                <el-row type="flex" justify="space-between">
                    <el-col class="option-title" :span="6">지역선택</el-col>
                    <el-col class="option-caution" :span="6">* 필수 입력</el-col>
                </el-row>

                <el-row :gutter="40" style="margin-top: 10px;">

                    <el-col :span="12">
                        <div
                                @click="handleCity(1)"
                                :class="[locationStep===1 ? 'select-city-box' : 'unselect-city-box']">
                            <span style="align-items: center;">{{cityParentsTitle}}</span>
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div
                                @click="handleCity(2)"
                                :class="[locationStep===2 ? 'select-city-box' : 'unselect-city-box']">
                            <span style="align-items: center;">{{cityChildTitle}}</span>
                        </div>
                    </el-col>

                    <div class="city-divider">
                        >
                    </div>

                </el-row>

                <el-row v-if="locationStep == 1" style="margin-top: 34px; position: relative;">
                    <el-row v-for="line in this.lineCount"
                            :key=line
                            :gutter="10"
                            style="margin-bottom: 10px;">

                        <el-col v-for="idx in 3"
                                :key=idx
                                :span="8">

                            <div class="unselect-detail-city-box"
                                 v-if="3 * (line - 1) + (idx - 1) < locations.length"
                                 v-text="locations[3 * (line - 1) + (idx - 1)].label"
                                 :class="[selectedParentsLocation != undefined && selectedParentsLocation == locations[3 * (line - 1) + (idx - 1)] ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleCityClick(locationStep, (3 * (line - 1) + (idx - 1)))">
                            </div>
                        </el-col>
                    </el-row>
                </el-row>

                <el-row v-if="locationStep == 2" style="margin-top: 34px; position: relative;">
                    <el-row v-for="line in this.childLineCount"
                            :key=line
                            :gutter="10"
                            style="margin-bottom: 10px;">

                        <el-col v-for="idx in 3"
                                :key=idx
                                :span="8">

                            <div class="unselect-detail-city-box"
                                 v-if="3 * (line - 1) + (idx - 1) < childLocations.length"
                                 v-text="childLocations[3 * (line - 1) + (idx - 1)].label"
                                 :class="[selectedChildLocation != undefined && selectedChildLocation == childLocations[3 * (line - 1) + (idx - 1)] ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleCityClick(locationStep, (3 * (line - 1) + (idx - 1)))">
                            </div>
                        </el-col>
                    </el-row>
                </el-row>
            </div>

            <div style="margin-left: 20px; margin-right: 20px; margin-top: 40px;">
                <el-row type="flex" justify="space-between">
                    <el-col class="option-title" :span="6">지원구분</el-col>
                </el-row>

                <div style="margin-top: 16px;">
                    <el-row :gutter="14">
                        <el-col :span="12">
                            <div :class="[coronaType == 0 ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleCoronaType(0)">
                                일반 지원
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div :class="[coronaType == 1 ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleCoronaType(1)">
                                코로나 지원
                            </div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 8px;">
                        <el-col>
                            <div :class="[coronaType == 2 ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleCoronaType(2)">
                                구분 없음
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <div style="margin-left: 20px; margin-right: 20px; margin-top: 40px;">
                <el-row type="flex" justify="space-between">
                    <el-col class="option-title" :span="6">소득구분</el-col>
                </el-row>

                <div style="margin-top: 16px;">
                    <el-row :gutter="14">
                        <el-col :span="12">
                            <div :class="[incomeType == 1 ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleIncomeType(1)">
                                건강보험료
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div :class="[incomeType == 0 ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleIncomeType(0)">
                                월 소득
                            </div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 8px;">
                        <el-col>
                            <div :class="[notMineIncome ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleNotMineIncome">
                                구분 없음
                            </div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 8px; width: 100%;" v-if="incomeType == 0 || incomeType == 1">
                        <el-col>
                            <div>
                                <input type="number" v-model="incomeValue" class="input-field"
                                       :placeholder="incomeHint"/>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <div style="margin-left: 20px; margin-right: 20px; margin-top: 40px;">
                <el-row type="flex" justify="space-between">
                    <el-col class="option-title" :span="6">출산구분</el-col>
                </el-row>

                <div style="margin-top: 16px;">
                    <el-row :gutter="14">
                        <el-col :span="12">
                            <div :class="[birthType == 0 ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleBirthType(0)">
                                임신 중
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div :class="[birthType == 1 ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleBirthType(1)">
                                출산 후
                            </div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 8px;">
                        <el-col>
                            <div :class="[notMineBirth ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleNotMineBirth">
                                구분 없음
                            </div>
                        </el-col>
                    </el-row>
                    <el-row style="margin-top: 8px;" v-if="birthType == 0 || birthType == 1">
                        <el-col>
                            <div>
                                <input type="number" v-model="birthValue" class="input-field" :placeholder="birthHint"/>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>

<!--            <div style="margin-left: 20px; margin-right: 20px; margin-top: 40px;">
                <div class="option-title">
                    신청유형
                </div>

                <div style="margin-top: 16px;">
                    <el-row :gutter="14">
                        <el-col :span="12">
                            <div :class="[applyOnline ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="applyOnline = !applyOnline">
                                온라인 신청
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div :class="[applyOffline ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="applyOffline = !applyOffline">
                                현장 신청
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>-->

            <div style="margin-left: 20px; margin-right: 20px; margin-top: 40px;">
                <el-row type="flex" justify="space-between">
                    <el-col class="option-title" :span="6">기타</el-col>
                </el-row>

                <div style="margin-top: 16px;">
                    <el-row :gutter="14">
                        <el-col :span="12">
                            <div :class="[requiredCard ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="requiredCard = !requiredCard, notMine = false">
                                지원카드 사업
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div :class="[multiCultural ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="multiCultural = !multiCultural, notMine = false">
                                다문화 가정
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="14" style="margin-top: 8px;">
                        <el-col :span="12">
                            <div :class="[disabled ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="disabled = !disabled, notMine = false">
                                장애 여부
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div :class="[secondTier ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="secondTier = !secondTier, notMine = false">
                                차상위계층
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="14" style="margin-top: 8px;">
                        <el-col :span="12">
                            <div :class="[oneParent ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="oneParent = !oneParent, notMine = false">
                                한부모 가정
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div :class="[basicIncome ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="basicIncome = !basicIncome, notMine = false">
                                기초수급대상
                            </div>
                        </el-col>
                    </el-row>

                    <el-row style="margin-top: 8px;">
                        <el-col>
                            <div :class="[notMine ? 'select_detail_item' : 'unselect_detail_item']"
                                 @click="handleNotMine">
                                해당 없음
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>

        <div class="apply-button"
             @click="handleOptionClick">
            나에게 꼭 맞는 지원금 찾기
        </div>
    </div>
</template>

<script>

    import {EventBus} from "@/event-bus";
    import firebase from "firebase/app";
    import 'firebase/analytics'

    export default {
        name: "newSearchMain",
        props: {
            locations: Array
        },
        data() {
            return {
                locationStep: 1,
                lineCount: 0,
                childLineCount: 0,
                cityParentsTitle: '시/도 선택',
                cityChildTitle: '시/군/구 선택',
                childLocations: [],
                selectedParentsLocation: undefined,
                selectedChildLocation: undefined,
                coronaType: 2,
                incomeType: 2,
                incomeValue: '',
                incomeHint: '건강보험료 및 월 소득 구분을 선택해 주세요.',
                birthType: 2,
                birthValue: '',
                birthHint: '임신 및 출산 여부를 선택해 주세요.',
                requiredCard: false,
                multiCultural: false,
                disabled: false,
                secondTier: false,
                oneParent: false,
                basicIncome: false,
                notMine: true,
                notMineIncome: true,
                notMineBirth: true,
                notMineCorona: true,
            }
        },
        beforeMount() {
            this.lineCount = parseInt((this.locations.length / 3) + (this.locations.length % 3));
            EventBus.$on("removeFilterOption", type => {

                if (type == 'location') {
                    this.locationStep = 1;
                    this.selectedParentsLocation = undefined;
                    this.selectedChildLocation = undefined;
                    this.cityParentsTitle = '시/도 선택';
                    this.cityChildTitle = '시/군/구 선택';
                } else if (type == 'birth') {
                    this.birthType = 2;
                    this.birthValue = '';
                    this.birthHint = '임신 및 출산 여부를 선택해 주세요.';
                } else if (type == 'income') {
                    this.incomeType = 2;
                    this.incomeValue = '';
                    this.incomeHint = '건강보험료 및 월 소득 구분을 선택해 주세요.';
                } else if (type == 'requireCard') {
                    this.requiredCard = false;
                } else if (type == 'multiCultural') {
                    this.multiCultural = false;
                } else if (type == 'disabled') {
                    this.disabled = false;
                } else if (type == 'secondTier') {
                    this.secondTier = false;
                } else if (type == 'oneParent') {
                    this.oneParent = false;
                } else if (type == 'basicIncome') {
                    this.basicIncome = false;
                } else if (type == 'corona') {
                    this.coronaType = 2;
                }

                this.handleOptionClick();
            })
        },
        beforeDestroy() {
            EventBus.$off("removeFilterOption")
        },
        methods: {
            getTs() {
                let date = new Date();

                let year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();

                if (month < 10) {
                    month = "0" + month
                }

                if (day < 10) {
                    day = "0" + day
                }

                if (hour < 10) {
                    hour = "0" + hour
                }

                if (minutes < 10) {
                    minutes = "0" + minutes
                }

                if (seconds < 10) {
                    seconds = "0" + seconds
                }

                return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
            },
            showMessage(message) {
                this.$message({
                    message: message,
                    type: 'warning',
                    showClose: true
                });
            },
            handleNotMine() {
                this.notMine = true;

                if (this.notMine) {
                    this.requiredCard = false;
                    this.multiCultural = false;
                    this.disabled = false;
                    this.secondTier = false;
                    this.oneParent = false;
                    this.basicIncome = false;
                }
            },
            handleNotMineBirth() {
                this.notMineBirth = true;

                if (this.notMineBirth) {
                    this.birthType = 2;
                }
            },
            handleNotMineIncome() {
                this.notMineIncome = true;

                if (this.notMineIncome) {
                    this.incomeType = 2;
                }
            },
            handleCity(position) {

                if (position === 1) {

                    if (this.locationStep == position) {
                        this.locationStep = 0;
                        return;
                    }

                    this.locationStep = position;
                } else {
                    if (this.selectedParentsLocation === undefined) {
                        this.showMessage("시/도를 먼저 선택해 주세요.")
                    } else {

                        if (this.selectedParentsLocation != undefined) {

                            if (this.selectedParentsLocation.value == 1) {
                                return;
                            }
                        }

                        if (this.locationStep == position) {
                            this.locationStep = 0;
                            return;
                        }

                        this.locationStep = 2
                    }
                }
            },
            handleCityClick(locationStep, idx) {

                let position = parseInt(idx);

                if (locationStep == 1) {
                    this.selectedParentsLocation = this.locations[position];

                    if (this.selectedParentsLocation.value == 1) {
                        this.selectedChildLocation = this.selectedParentsLocation;
                        this.cityChildTitle = '해당 없음';
                        this.locationStep = 0;
                    } else {
                        this.selectedChildLocation = undefined;
                        this.childLocations = this.selectedParentsLocation.children;
                        this.childLineCount = parseInt(String(this.childLocations.length / 3)) + this.childLocations.length % 3;
                        this.cityChildTitle = '시/군/구 선택';
                        this.locationStep = 2;
                    }

                    this.cityParentsTitle = this.selectedParentsLocation.label;

                } else if (locationStep == 2) {
                    this.selectedChildLocation = this.childLocations[position];
                    this.cityChildTitle = this.selectedChildLocation.label;
                    this.locationStep = 0;
                }
            },
            handleIncomeType(type) {

                this.notMineIncome = false;
                this.incomeType = type;

                if (type == 0) {
                    this.incomeHint = "월 소득을 입력해 주세요.";
                } else if (type == 1) {
                    this.incomeHint = "건강보험료를 입력해 주세요.";
                }
            },
            handleCoronaType(type) {

                this.notMineCorona = false;
                this.coronaType = type;
            },
            handleBirthType(type) {

                this.notMineBirth = false;
                this.birthType = type;

                if (type == 0) {
                    this.birthHint = "임신 몇 개월이신가요?";
                } else if (type == 1) {
                    this.birthHint = "출산 몇 개월이신가요?";
                }
            },
            handleReset() {
                this.selectedChildLocation = undefined;
                this.selectedParentsLocation = undefined;
                this.locationStep = 1;
                this.incomeType = 2;
                this.birthType = 2;
                this.cityParentsTitle = '시/도 선택';
                this.cityChildTitle = '시/군/구 선택';
                this.incomeHint = '건강보험료 및 월 소득 구분을 선택해 주세요.';
                this.birthHint = '임신 및 출산 여부를 선택해 주세요.';
                this.requiredCard = false;
                this.multiCultural = false;
                this.disabled = false;
                this.secondTier = false;
                this.oneParent = false;
                this.basicIncome = false;
                this.incomeValue = '';
                this.birthValue = '';
                this.coronaType = 2;

                EventBus.$emit("resetEvent");
            },
            handleOptionClick() {

                if (this.selectedChildLocation == undefined) {
                    this.showMessage("지역을 선택한 후 적용을 눌러주세요.")
                } else {

                    if (this.incomeType != 2) {

                        if (this.incomeValue == '') {
                            this.showMessage("선택한 소득구분에 대하여 금액을 입력해 주세요.");
                            return
                        }
                    }

                    if (this.birthType != 2) {

                        if (this.birthValue == '') {
                            this.showMessage("선택한 출산구분에 대하여 금액을 입력해 주세요.");
                            return
                        }
                    }


                    let searchInfo = {
                        title: 'all',
                        parentLocation: this.selectedParentsLocation,
                        childLocation: this.selectedChildLocation,
                        child_birth_type: this.birthType,
                        child_birth: this.birthValue.length > 0 ? parseInt(this.birthValue) : 0,
                        income_type: this.incomeType,
                        income: this.incomeValue.length > 0 ? parseInt(this.incomeValue) : 0,
                        require_card: this.requiredCard ? 1 : 0,
                        multi_cultural: this.multiCultural ? 1 : 0,
                        disabled: this.disabled ? 1 : 0,
                        second_tier: this.secondTier ? 1 : 0,
                        one_parent: this.oneParent ? 1 : 0,
                        basic_income: this.basicIncome ? 1 : 0,
                        is_corona: this.coronaType
                    };

                    firebase.analytics().logEvent('clickSearchButton', {
                        ts : this.getTs()
                    });

                    this.$emit('handleSearch', searchInfo)
                }
            },
            handleExit() {
                this.$emit('closeFilterPage')
            }
        }
    }
</script>

<style>

    body html {
        width: 100%;
        margin: 0;
        padding: 0;
    }

    .app-bar {
        position: fixed;
        top: 0;
        height: 50px;
        width: 100%;
        background: white;
        z-index: 100;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: solid 1px #ededed;
        max-width: 1024px;
    }

    .app-bar-title {
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        text-align: center;
        color: #333333;
    }

    .app-bar-item {
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        color: #333333;
    }

    .app-bar-close {
        margin-left: 16px;
        position: absolute;
        left: 0;
    }

    .app-bar-reset {
        margin-right: 16px;
        position: absolute;
        right: 0;
    }

    .option-title {
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        color: #333333;
    }

    .option-caution {
        text-align: right;
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        color: #f37207
    }

    .location-select-container {
        margin-left: 20px;
        margin-right: 20px;
        padding-top: 25px;
        height: auto;
    }

    .select-city-box {
        padding-top: 10px;
        padding-bottom: 10px;
        border: solid 1px #555555;
        background-color: #f8f8f8;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        color: #333333;
        z-index: 10;
    }

    .unselect-city-box {
        padding-top: 10px;
        padding-bottom: 10px;
        border: solid 1px #dadada;
        background-color: #f8f8f8;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        color: #999999;
        z-index: 10;
    }

    .city-divider {
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #333333;
        position: absolute;
        left: 45%;
        right: 45%;
        text-align: center;
        margin-top: 10px;
        z-index: 0;
    }

    .unselect-detail-city-box {
        border: solid 1px #dadada;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.28px;
        color: #999999;
    }

    .select_detail_item {
        padding-top: 10px;
        padding-bottom: 10px;
        border: solid 1px #555555;
        background-color: #555555;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        color: #ffffff;
    }

    .unselect_detail_item {
        padding-top: 10px;
        padding-bottom: 10px;
        border: solid 1px #dadada;
        font-size: 14px;
        font-weight: 500;
        color: #999999;
    }

    .input-field[type=number] {
        padding: 10px 12px 10px 12px;
        border: solid 1px #dadada;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        color: #333333;
        caret-color: #ff8c09;
        box-sizing: border-box;
        outline: none;
        width: 100%;
    }

    .input-field[type=text]:focus {
        padding: 10px 12px 10px 12px;
        border: solid 1px #555555;
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        color: #333333;
        caret-color: #ff8c09;
        box-sizing: border-box;
        outline: none;
        width: 100%;
    }

    .apply-button {
        margin-left: auto;
        margin-right: auto;
        max-width: 1024px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding-top: 14px;
        padding-bottom: 14px;
        background-color: #ffea6d;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        text-align: center;
        color: #333333;
    }

    .helper-text {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: -0.3px;
        color: #777777;
    }
</style>